const hasRequestError = (response: any) => {
  return (
    response.status !== 200 ||
    !response.data.isSuccess ||
    (response.data.statusCode && response.data.statusCode !== 200)
  );
};

export const throwErrorMessage = (response: any) => {
  if (
    response.status !== 200 ||
    !response.data.isSuccess ||
    (response.data.statusCode && response.data.statusCode !== 200)
  ) {
    let error =
      response.data.message === "FAIL"
        ? response.data.result
        : response.data.displayMessage;

    if (!error) {
      error = "No data found!";
    }

    throw new Error(error);
  }
};

export default hasRequestError;
